var map = {
	"./ca.png": 4008,
	"./cn.png": 7286,
	"./de.png": 9763,
	"./es.png": 2687,
	"./fr.png": 7427,
	"./gb.png": 231,
	"./id.png": 5277,
	"./it.png": 9643,
	"./ph.png": 2971,
	"./um.png": 8875,
	"./va.png": 4783
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7394;